import * as PropTypes from 'prop-types';

import * as FileConstants from 'folder-items/FileConstants';
import {BioentitySummary} from 'folder-items/FileConstants';
import * as SchemaFieldConstants from 'schemas/fields/SchemaFieldConstants';
import {SchemaField} from 'schemas/fields/SchemaFieldConstants';

export const BULK_ANTIBODY_SCREEN = 'BULK_ANTIBODY_SCREEN';

export enum Step {
  BULK_TRANSLATION = 'BULK_TRANSLATION',
  BULK_ANTIBODY = 'BULK_ANTIBODY',
}

export interface BioentityLinkSpec {
  tagSchemaField: SchemaField;
  files: Array<BioentitySummary>;
}

export const BIOENTITY_LINK_SPEC_SHAPE = PropTypes.shape({
  tagSchemaField: SchemaFieldConstants.SCHEMA_FIELD_SHAPE.isRequired,
  files: PropTypes.arrayOf(FileConstants.FILE_SUMMARY_SHAPE.isRequired).isRequired,
});

export interface BulkAntibody {
  step: Step;
  tagSchemaId?: string;
  antibodyNamePrefix: string;
  outputFolderId?: string;
  bioentityLinkSpecs: Array<BioentityLinkSpec>;
  inputFiles: Array<BioentitySummary>;
  inputFilesLoading: boolean;
  isCreating: boolean;
}

export const BULK_ANTIBODY = PropTypes.shape({
  step: PropTypes.oneOf(Object.values(Step)).isRequired,
  tagSchemaId: PropTypes.string,
  antibodyNamePrefix: PropTypes.string.isRequired,
  outputFolderId: PropTypes.string,
  bioentityLinkSpecs: PropTypes.arrayOf(BIOENTITY_LINK_SPEC_SHAPE.isRequired).isRequired,
  inputFiles: PropTypes.arrayOf(FileConstants.FILE_SUMMARY_SHAPE.isRequired).isRequired,
  inputFilesLoading: PropTypes.bool.isRequired,
  isCreating: PropTypes.bool.isRequired,
});
